import React from 'react';
import { phases, programs, challengeType } from '../../../constant/academic';

export default function AssignmentFilter({
  filterInput,
  setFilterInput,
  fetchFn,
}) {
  const changeFilterInput = (e) => {
    const field = e.target.name;
    setFilterInput({
      ...filterInput,
      [field]: e.target.value,
    });
  };
  return (
    <>
      <form
        className="text-center"
        onSubmit={(e) => {
          e.preventDefault();
          fetchFn();
        }}
      >
        <div>
          <div className="mb-2 flex rounded-md shadow-sm border border-gray-300">
            <span className="w-1/3 inline-flex items-center px-3 rounded-l-md  bg-gray-50 text-gray-500 sm:text-sm">
              Name
            </span>
            <input
              type="text"
              name="name"
              onChange={changeFilterInput}
              value={filterInput.name}
              className="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300"
              placeholder="assignment name..."
            />
          </div>
        </div>
        <div>
          <div className="mb-2 flex rounded-md shadow-sm border border-gray-300 pr-2">
            <span className="w-1/3  inline-flex items-center px-3 rounded-l-md  bg-gray-50 text-gray-500 sm:text-sm">
              Type
            </span>
            <select
              name="type"
              onChange={changeFilterInput}
              value={filterInput.type}
              className="bg-white outline-none flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300"
            >
              {challengeType.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div>
          <div className="mb-2 flex rounded-md shadow-sm border border-gray-300 pr-2">
            <span className="inline-flex w-1/3 items-center px-3 rounded-l-md  bg-gray-50 text-gray-500 sm:text-sm">
              Program
            </span>
            <select
              name="program"
              onChange={changeFilterInput}
              value={filterInput.program}
              className="bg-white outline-none flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300"
            >
              {programs.map((val) => (
                <option key={val} value={val}>
                  {val}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div>
          <div className="mb-2 flex rounded-md shadow-sm border border-gray-300 pr-2">
            <span className="w-1/3 inline-flex items-center px-3 rounded-l-md  bg-gray-50 text-gray-500 sm:text-sm">
              Phase
            </span>
            <select
              onChange={changeFilterInput}
              name="phase"
              value={filterInput.phase}
              className="flex-1 outline-none min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 bg-white sm:text-sm border-gray-300"
            >
              {phases.map((phase) => (
                <option key={phase} value={phase}>
                  {phase}
                </option>
              ))}
            </select>
          </div>
        </div>
        <button
          type="submit"
          className="w-full text-center  border border-transparent text-xs font-medium rounded  text-white bg-indigo-600 hover:bg-indigo-700 py-2"
        >
          SEARCH ASSIGNMENT
        </button>
      </form>
    </>
  );
}
